import React, { Component } from 'react';
import marked from 'marked';

export default class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = { markdown: null, scrolled: true };
        const readmePath = require('./README.md');

        fetch(readmePath)
            .then(response => {
                return response.text();
            })
            .then(text => {
                this.setState({ markdown: marked(text) });
            });
    }

    renderTopButton() {
        return (
            <button
                style={{
                    position: 'sticky',
                    bottom: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}
                onClick={() => window.scrollTo(0, 0)}
            >
                <img
                    style={{ transform: 'rotate(180deg)', opacity: 0.4 }}
                    src={require('../images/drop_down.png')}
                    alt="back to top button"
                />
            </button>
        );
    }

    render() {
        return (
            <div style={{ marginTop: this.props.hideTop ? '-25px' : null }}>
                <section style={{ margin: this.props.hideTop ? 0 : '0 15px' }}>
                    <article dangerouslySetInnerHTML={{ __html: this.state.markdown }} />
                </section>
                {this.props.hideTop ? null : this.renderTopButton()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Profile.js